<template>
  <section>
    <loading v-show="showLoader"/>

    <div class="container multistep-box" style="margin: 50px auto 20px; text-align: center; padding-top: 50px; padding-bottom:40px;">
      <form @submit.prevent="submitContact()" id="bootstrapForm">
        <div class="row">
          <div class="col-md-6">
            <div>
              <label class="label-d-block">First Name</label>
              <div class="jbl-field">
                <input class="jbl-dynamic-input" type="text" placeholder="Your First Name" v-model="contact.first_name">
              </div>
              <div v-if="contactErrors.filter(x => x.field == 'first_name').length > 0">
                <div class="d-block jbl-text-danger">
                  <small class="text-danger">{{contactErrors.filter(x => x.field == 'first_name')[0].message}}</small>
                </div>
              </div>
            </div>
            <div>
              <label class="label-d-block">Last Name</label>
              <div class="jbl-field">
                <input class="jbl-dynamic-input" type="text" placeholder="Your Last Name" v-model="contact.last_name">
              </div>
              <div v-if="contactErrors.filter(x => x.field == 'last_name').length > 0">
                <div class="d-block jbl-text-danger">
                  <small class="text-danger">{{contactErrors.filter(x => x.field == 'last_name')[0].message}}</small>
                </div>
              </div>
            </div>
            <div>
              <label class="label-d-block">Mobile Number</label>
              <div class="jbl-field">
                <input class="jbl-dynamic-input" type="text" placeholder="Your Mobile Number" v-model="contact.mobile_no" v-mask="'+92##########'" @input="validateMobileNo($event)">
              </div>
              <div v-if="contactErrors.filter(x => x.field == 'mobile_no').length > 0">
                <div class="d-block jbl-text-danger">
                  <small class="text-danger">{{contactErrors.filter(x => x.field == 'mobile_no')[0].message}}</small>
                </div>
              </div>
            </div>
            <div>
              <label class="label-d-block">Email</label>
              <div class="jbl-field">
                <input class="jbl-dynamic-input" type="text" placeholder="Your Email" v-model="contact.email">
              </div>
              <div v-if="contactErrors.filter(x => x.field == 'email').length > 0">
                <div class="d-block jbl-text-danger">
                  <small class="text-danger">{{contactErrors.filter(x => x.field == 'email')[0].message}}</small>
                </div>
              </div>
            </div>
            <div class="my-3 d-block d-md-none">
              <button type="submit" class="ib-btn-primary ib-btn-width">Submit</button>
            </div>
          </div>
          <div class="col-md-6 text-left">
            <h3 class="contact-right-title">Catch Us Any Time</h3>
            <div class="w-100 mb-4">
              <div class="d-flex">
                <div class="ib-mr-15">
                  <img class="img-fluid" :src="require('@/assets/images/contact-locations.svg')" alt="icon" />
                </div>
                <div>
                  <h4 class="contact-right-heading">FIND US</h4>
                  <p class="contact-right-desc">
                    1st Floor, Plaza #46 <span style="position: relative; bottom: 3px;">|</span> Commercial Area, Z-Block <span style="position: relative; bottom: 3px;">|</span> DHA, Lahore (Pakistan)
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 mb-4">
              <div class="d-flex">
                <div class="ib-mr-15">
                  <img class="img-fluid" :src="require('@/assets/images/call-message-icon.svg')" alt="icon" />
                </div>
                <div>
                  <h4 class="contact-right-heading">Message &amp; CALL</h4>

                  <a class="contact-right-desc in-flex-icon" href="tel:021654898909">
                    <div class="in-icon-relative">
                        <img class="img-fluid" :src="require('@/assets/images/whatsapp-icon.svg')" style="margin-top: -13px !important;" alt="image"/>
                      </div>
                    <div class="in-contact-number{">(0300) 0146666</div>
                  </a>
                </div>
              </div>
            </div>
            <div class="w-100 mb-4">
              <div class="d-flex">
                <div class="ib-mr-15">
                  <img class="img-fluid" :src="require('@/assets/images/contact-email.svg')" alt="icon" />
                </div>
                <div>
                  <h4 class="contact-right-heading">FEEDBACK &amp; COMPLAINTS</h4>
                  <a class="contact-right-desc" href="mailto:info@insurancebazaar.com.pk">info@insurancebazaar.com.pk</a>
                  <br>
                  <a class="contact-right-desc" href="mailto:complaints@insurancebazaar.com.pk">complaints@insurancebazaar.com.pk</a>
                </div>
              </div>
            </div>
          </div>
          <div class="my-3 row mx-auto d-none d-md-block">
              <button type="submit" class="ib-btn-primary ib-btn-width">Submit</button>
            </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
  import loading from '@/components/Loading/Loading';
  import {mask} from "vue-the-mask";

  export default {
    name: 'ContactHomeSection',
    components:{
      loading
    },
    directives: { mask },
    data() {
      return {
        showLoader: false,
        contact: {
          first_name: '',
          last_name: '',
          mobile_no: '',
          email: ''
        },
        contactErrors: []
      }
    },
    methods: {
      // verifyEmail (event) {
      //   const self = this;
      //
      //   self.contactErrors = [];
      //   let email = event.target.value;
      //   if(email == '') {
      //     return false;
      //   }
      //
      //   const re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      //   let result = re.test(String(email).toLowerCase());
      //   if(!result) {
      //     self.contactErrors.push({
      //       field: 'email',
      //       message: 'Invalid Email'
      //     });
      //   }
      // },
      validateMobileNo (event) {
        const self = this;
        let val = event.target.value;
        if(val != "") {
          const usingSplit = val.split('');
          let issue = false;

          let i = 0;
          for (i; i < 4; i++) {
            if(usingSplit[i] === '0') {
              issue = true;
              break;
            }
          }

          if (issue) {
            event.target.value = '+92';
            self.contact.mobile_no = '+92';
          }
        }
      },
      async submitContact () {
        const self = this;
        self.contactErrors = [];
        Object.entries(self.contact).forEach(([key, value]) => {
          if (value.trim() == '') {
            self.contactErrors.push({
              field: key,
              message: key.replace(/_/g,' ') + ' required'
            });
          }
        });
        if( self.contact.mobile_no.length < 13){
          self.contactErrors.push({
            field: 'mobile_no',
            message:  'Mobile No is incorrect'
          });
        }
        if(self.contact.email !== undefined && self.contact.email !== '') {
          const re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          let result = re.test(String(self.contact.email).toLowerCase());
          if(!result) {
            self.contactErrors.push({
              field: 'email',
              message: 'Invalid Email'
            });

          }
        }

        if (self.contactErrors.length > 0) {
          return false;
        }
        console.log('1');
        var formData = new FormData();
        formData.append('first_name', self.contact.first_name.trim());
        formData.append('last_name', self.contact.last_name.trim());
        formData.append('mobile_no', self.contact.mobile_no.trim());
        formData.append('email', self.contact.email);

        self.showLoader = true;
        await axios.post('contact_us', formData).then(function (resp) {
          if(resp.data.code == 200) {
            $toast.success('Thank you for your message. Our Call Center representative will contact you within 24 hours.', { position: 'top-right' });
            self.contact = {
              first_name: '',
              last_name: '',
              mobile_no: '',
              email: ''
            }
          } else {
            $toast.error(resp.data.message, { position: 'top-right' })
            return false;
          }
          self.showLoader = false;
        }).catch(error => {
          error.response.data.errors.forEach(element => {
            self.stepOneErrors.push(element);
          })
          self.showLoader = false;
        });
      }
    }
  }
</script>

<style scoped>
  .label-d-block {
    display: block !important;
    text-align: left;
  }
  .contact-right-title {
    margin: 0px 0px 20px;
    -webkit-text-stroke: 1px rgba(0, 0, 0, 0);
    font-family: "Avenir Medium";
    font-size: 20px;
    font-weight: 500;
    color: #ef7c94;
  }
  .contact-right-heading {
    margin: 0px 0px 10px;
    opacity: 0.7;
    font-family: "Avenir Book";
    font-size: 14px;
    color: #5b6770;
    text-transform: uppercase;
  }
  .contact-right-desc {
    margin: 0px;
    -webkit-text-stroke: 1px rgba(0, 0, 0, 0);
    font-family: "Avenir Medium";
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: left;
    color: #3d9cbd;
  }
  @media (max-width:550px) {
    .contact-right-desc {
      font-size: 16px !important;
    }
  }
  .jbl-text-danger {
    text-align: left;
    padding-left: 3px;
  }
  .in-icon-relative {
    position: relative;
    top: 5px;
    right: 2px;
  }
  .in-contact-number {
    position: relative;
    left: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact/ContactHomeSection.vue